import Vue from 'vue'

const state = {
  presential_filters: {},
  users_filters: {},
  branches_filters: {},
  companies_filters: {},
  trainings_filters: {},
  live_classes_filters: {},
  trails_filters: {},
  webcasts_filters: {},
  podcasts_filters: {},
  library_filters: {}
}

const actions = {
  SET_PRESENTIAL_FILTERS(context, {presential_filters}) {
    context.commit('SAVE_PRESENTIAL_FILTERS', {presential_filters})
  },

  SET_USERS_FILTERS(context, {users_filters}) {
    context.commit('SAVE_USERS_FILTERS', {users_filters})
  },

  SET_BRANCHES_FILTERS(context, {branches_filters}) {
    context.commit('SAVE_BRANCHES_FILTERS', {branches_filters})
  },

  SET_COMPANIES_FILTERS(context, {companies_filters}) {
    context.commit('SAVE_COMPANIES_FILTERS', {companies_filters})
  },

  SET_TRAININGS_FILTERS(context, {trainings_filters}) {
    context.commit('SAVE_TRAININGS_FILTERS', {trainings_filters})
  },

  SET_LIVE_CLASSES_FILTERS(context, {live_classes_filters}) {
    context.commit('SAVE_LIVE_CLASSES_FILTERS', {live_classes_filters})
  },

  SET_TRAILS_FILTERS(context, {trails_filters}) {
    context.commit('SAVE_TRAILS_FILTERS', {trails_filters})
  },

  SET_WEBCASTS_FILTERS(context, {webcasts_filters}) {
    context.commit('SAVE_WEBCASTS_FILTERS', {webcasts_filters})
  },

  SET_PODCASTS_FILTERS(context, {podcasts_filters}) {
    context.commit('SAVE_PODCASTS_FILTERS', {podcasts_filters})
  },

  SET_LIBRARY_FILTERS(context, {library_filters}) {
    context.commit('SAVE_LIBRARY_FILTERS', {library_filters})
  }
}

const mutations = {
  SAVE_PRESENTIAL_FILTERS: (state, {presential_filters}) => {
    Vue.set(state, 'presential_filters', presential_filters)
  },

  SAVE_USERS_FILTERS: (state, {users_filters}) => {
    Vue.set(state, 'users_filters', users_filters)
  },

  SAVE_BRANCHES_FILTERS: (state, {branches_filters}) => {
    Vue.set(state, 'branches_filters', branches_filters)
  },

  SAVE_COMPANIES_FILTERS: (state, {companies_filters}) => {
    Vue.set(state, 'companies_filters', companies_filters)
  },

  SAVE_TRAININGS_FILTERS: (state, {trainings_filters}) => {
    Vue.set(state, 'trainings_filters', trainings_filters)
  },

  SAVE_LIVE_CLASSES_FILTERS: (state, {live_classes_filters}) => {
    Vue.set(state, 'live_classes_filters', live_classes_filters)
  },

  SAVE_TRAILS_FILTERS: (state, {trails_filters}) => {
    Vue.set(state, 'trails_filters', trails_filters)
  },

  SAVE_WEBCASTS_FILTERS: (state, {webcasts_filters}) => {
    Vue.set(state, 'webcasts_filters', webcasts_filters)
  },

  SAVE_PODCASTS_FILTERS: (state, {podcasts_filters}) => {
    Vue.set(state, 'podcasts_filters', podcasts_filters)
  },

  SAVE_LIBRARY_FILTERS: (state, {library_filters}) => {
    Vue.set(state, 'library_filters', library_filters)
  }
}

const getters = {
  presential_filters: state => {
    return state.presential_filters
  },

  users_filters: state => {
    return state.users_filters
  },

  branches_filters: state => {
    return state.branches_filters
  },

  companies_filters: state => {
    return state.companies_filters
  },

  trainings_filters: state => {
    return state.trainings_filters
  },

  live_classes_filters: state => {
    return state.live_classes_filters
  },

  trails_filters: state => {
    return state.trails_filters
  },

  webcasts_filters: state => {
    return state.webcasts_filters
  },

  podcasts_filters: state => {
    return state.podcasts_filters
  },

  library_filters: state => {
    return state.library_filters
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
